import { TableView } from 'owa-mail-list-store';

/*
    We maintain a list of most recently used 5 tables by storing the tablesId in the MRU list.
    Whenever a new table is added to the MRU, we subscribe to the row notifications.
    Whenever a table id entry is removed from the MRU we unsubscribe to the row notifications.
    This means at any time only 5 tables are active\live.
    VSO-18425 - Use mruCache class from client-framework instead
*/
let tableIdList: string[];
let capacity: number = 5;
let onAdd: (tableView: TableView) => any;
let onRemove: (tableViewId: string) => any;

function add(tableView: TableView) {
    tableIdList.unshift(tableView.id);
    onAdd(tableView);
    invalidateOldEntries();
}

function bumpToFront(tableView: TableView) {
    const entry = tableView.id;
    tableIdList.splice(tableIdList.indexOf(entry), 1);
    tableIdList.unshift(entry);
}

function invalidateOldEntries() {
    if (tableIdList.length > capacity) {
        for (let i = capacity; i < tableIdList.length; i++) {
            remove(tableIdList[i]);
        }
    }
}

export function initialize(
    onAddCallback: (tableView: TableView) => any,
    onRemoveCallback: (tableViewId: string) => any,
    listCapacity: number
) {
    tableIdList = [];
    onAdd = onAddCallback;
    onRemove = onRemoveCallback;
    capacity = listCapacity;
}

/**
 * Removes entry from the MRU table id list
 * @param tableViewId the id of tableView
 */
export function remove(tableViewId: string) {
    const index = tableIdList.indexOf(tableViewId);

    if (index == -1) {
        throw new Error('TableViewId should be present in the mru list when remove is called');
    }

    tableIdList.splice(index, 1);
    onRemove(tableViewId);
}

export function update(tableView: TableView): number {
    const entryIndex = tableIdList.indexOf(tableView.id);

    switch (entryIndex) {
        case -1:
            add(tableView);
            break;
        case 0:
            break;
        default:
            bumpToFront(tableView);
    }

    return entryIndex;
}

export function getMRUTableId(): string | null {
    return tableIdList ? tableIdList[0] : null;
}

export function canAddToList(): boolean {
    return tableIdList.length < capacity;
}
